import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'cmg-clear2-ui-login-footer',
  templateUrl: './login-footer.component.html',
  styleUrls: ['./login-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginFooterComponent {}
